import { useTranslation } from 'react-i18next';
export function useDocumentLibraryTranslations() {
    return useTranslation('document-library');
}
